import {DownloadMode} from 'common/report/constants';
import {getDownloadMode, isDigestMode, isTvMode} from 'common/report/util';
import {createElem} from 'common/util/dom';

let initialized = false;
const OPTIMIZELY_SCRIPT_SRC = `https://cdn.optimizely.com/js/5838709522694144.js`;

export async function initOptimizely() {
  if (getDownloadMode() !== DownloadMode.None || isDigestMode() || isTvMode() || !window.gdprData || initialized) {
    initialized = true;
    return;
  }

  const gdprData = window.gdprData;
  if (!gdprData.isReady) {
    await gdprData.waitUntilReady();
  }

  if (!gdprData.allowSnippets || !gdprData.allowTracking) {
    initialized = true;
    return;
  }

  if (!document.head.querySelector(`script[src='${OPTIMIZELY_SCRIPT_SRC}']`)) {
    document.head.appendChild(
      createElem(`script`, {
        src: OPTIMIZELY_SCRIPT_SRC,
        'data-cfasync': `false`,
        async: true,
        defer: true,
        type: `text/javascript`,
      }),
    );
  }

  initialized = true;
}

export function optOutOptimizely() {
  // @ts-ignore
  if (window.optimizely) {
    // @ts-ignore
    window.optimizely.push({
      type: `optOut`,
      isOptOut: true,
    });
  }
}

export function optInOptimizely() {
  // @ts-ignore
  if (window.optimizely) {
    // @ts-ignore
    window.optimizely.push({
      type: `optOut`,
      isOptOut: false,
    });
  }
}
